import {Directive, inject, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[appContainerDirective]',
  standalone: true
})
export class ContainerDirective {
  viewContainerRef = inject(ViewContainerRef);
}
